<template>
  <nav>
    <div class="title-container round-hover-effect pointer">
      <router-link to="/"><h3>Goxip Admin</h3></router-link>
    </div>
    <div class="nav-container">
      <el-tooltip
        effect="dark"
        content="Upload Image"
        placement="bottom"
      >
        <a
          class="action-button round-hover-effect pointer"
          @click="showFileUploadModal"
        >
          <i class="el-icon-upload" />
        </a>
      </el-tooltip>

      <el-tooltip
        effect="dark"
        content="Full Screen"
        placement="bottom"
      >
        <full-screen class="action-button round-hover-effect" />
      </el-tooltip>
      <el-dropdown
        trigger="click"
        @visible-change="dropdownVisibleChanged"
        @command="handleDropdownCommands"
      >
        <div class="settings-container round-hover-effect pointer">
          <p class="username">{{ userName }}</p>
          <font-awesome-icon
            :class="{ 'reverse': isDropdownOpen }"
            class="font-awesome-icon"
            icon="angle-down"
          />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            <span>{{ $t('navbar.logout') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FullScreen from '../../../components/FullScreen.vue'

export default {
  components: {
    FullScreen,
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'app/sidebar',
      userName: 'user/name',
    }),
  },
  methods: {
    ...mapActions({
      setShowFileUploadModal: 'file/setShowFileUploadModal',
    }),
    handleDropdownCommands(command) {
      switch (command) {
        case 'logout':
          this.logout()
          break
        default:
          break
      }
    },
    async logout() {
      try {
        await this.$store.dispatch('user/logout')
        this.$router.push({ path: '/login' })
      } catch (error) {
        // Handle later
      }
    },
    dropdownVisibleChanged(isShow) {
      this.isDropdownOpen = isShow
    },
    showFileUploadModal() {
      this.setShowFileUploadModal(true)
    },
  },
}
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: $nav-bar-height;
  padding: 0 20px;
  background-color: $nav-bar-color;
  color: white;
  z-index: $z-index-top-most;
  font-weight: 600;

  .title-container {
    display: flex;
    padding: 2px 5px;
    h3 {
      margin: auto;
    }
  }

  .nav-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .action-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      margin: auto 5px auto auto;
    }
    .settings-container {
      display: flex;
      padding: 2px 8px;
      color: white;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        padding: 5px;
        margin: auto;
        border-radius: $border-radius-circle;
      }
      .username {
        margin: auto 5px;
        text-transform: capitalize;
      }
      .font-awesome-icon {
        @include transition(transform .3s);
        &.reverse {
          @include transform(rotate(-180deg));
        }
      }
    }
  }
}
</style>
